
import { IoMdNotifications } from "react-icons/io";
import { IoTimeOutline } from "react-icons/io5";

function NotificationCard({ notification, onClick }) {
  return (
    <div
      onClick={onClick}
      className="flex gap-3 p-4 rounded-xl border border-gray-100 bg-white hover:bg-gray-50 transition-colors shadow-sm cursor-pointer"
    >
      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-orange-50 flex items-center justify-center">
        <IoMdNotifications className="text-orange-500 text-xl" />
      </div>

      <div className="flex flex-col flex-1 min-w-0 gap-2">
        <h3 className="text-sm font-bold text-gray-800">
          {notification.title}
        </h3>

        <p className="text-sm text-gray-600 truncate">
          {notification.body}
        </p>

        <div className="flex items-center gap-1.5 text-xs text-gray-400">
          <IoTimeOutline />
          <span>
            {new Date(notification.createdAt).toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
}

export default NotificationCard;
